export class Token {
  id: string;
  comment: string;
  role: string;
  access_token: string;
  created_at: string;

  constructor(payload: Object = {}) {
    Object.assign(this, payload);
  }
}
